import React from 'react'
import "./Footer.css"

const  Footer = () => {
 return (
  <div className="footer">
    <h3> {'\u00A9' }kevin Shikuku</h3>
  </div>
 )
}
 export default Footer;
